var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[(_vm.permissionInfo && _vm.permissionInfo.is_show_rejects)?_c('reject-list',{attrs:{"data":_vm.rejectData}}):_vm._e(),_c('my-form',{ref:"myForm",attrs:{"data":_vm.baseFormData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }